import { useEmblaCarousel } from 'embla-carousel/react'
import PropTypes from 'prop-types'
import { Children, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

const Viewport = styled.div`
  overflow: hidden;
  width: 100%;
`

const Container = styled.div`
  width: auto;
  display: flex;
  align-items: stretch;
  gap: ${getToken('space-s')};
`

const Slide = styled.div`
  box-sizing: border-box;
  position: relative;

  min-width: 320px;
  width: 80%;

  ${screen.lg} {
    min-width: 32%;
    width: 100%;
  }
`

const DotList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getToken('space-xs')};
`

const Dot = styled.button`
  margin: 0;
  padding: 0;
  width: 8px;
  height: 8px;
  border: none;
  border-radius: 100%;
  line-height: 0;
  overflow: hidden;
  background: ${props =>
    props.active ? getToken('color-neutral-dark') : getToken('color-neutral-lighter')};
  color: ${props =>
    props.active ? getToken('color-neutral-dark') : getToken('color-neutral-lighter')};
`

function TopOffersCarousel(props) {
  const { children } = props
  const [emblaRef, embla] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
  })
  const [scrollSnaps, setScrollSnaps] = useState([])
  const [currentSlide, setCurrentSlide] = useState(0)

  const scrollTo = useCallback(index => embla && embla.scrollTo(index), [embla])
  const onSelect = useCallback(() => {
    if (!embla) return
    setCurrentSlide(embla.selectedScrollSnap())
  }, [embla])

  useEffect(() => {
    if (!embla) return
    onSelect()
    setScrollSnaps(embla.scrollSnapList())
    embla.on('select', onSelect)

    return () => {
      embla.off('select', onSelect)
    }
  }, [embla, onSelect, setScrollSnaps])

  return (
    <>
      <Viewport ref={emblaRef}>
        <Container>
          {Children.map(children, (child, index) => (
            <Slide key={`slide-${index}`} active={currentSlide === index}>
              {child}
            </Slide>
          ))}
        </Container>
      </Viewport>
      {scrollSnaps.length > 1 && (
        <DotList>
          {scrollSnaps.map((_, index) => (
            <Dot
              key={`dot-${index}`}
              active={currentSlide === index}
              onClick={() => scrollTo(index)}
            >
              {`Item ${index}`}
            </Dot>
          ))}
        </DotList>
      )}
    </>
  )
}

TopOffersCarousel.propTypes = {
  children: PropTypes.node.isRequired,
}

export { TopOffersCarousel }
